<template>
  <button
    type="button"
    class="tile">
    <div class="icon">
      <SvgIcon :name="icon"/>
    </div>
    <div class="title">
      {{ $t(title) }}
    </div>
    <p> {{ $t(description) }} </p>
  </button>
</template>

<script setup lang="ts">
import SvgIcon from '@/_redesign/shared/ui/SvgIcon/SvgIcon.vue';

const { icon, title, description } = defineProps<{
  icon: string;
  title: string;
  description: string;
}>();
</script>

<style scoped>
.tile {
  @apply flex flex-col items-center pt-40 pb-32 px-16 w-192 min-h-206;
  @apply text-center border border-old-n-gray-10 rounded-[12px] shadow-tile bg-old-n-white;
  @apply hover:bg-old-n-gray-0 active:bg-old-n-gray-10;
}

.icon {
  @apply flex items-center justify-center w-48 h-48 mb-16;
  @apply rounded-full text-old-white bg-old-n-blue-90;

  i::before {
    @apply text-[23px];
  }
}

.title {
  @apply pb-8;
  @apply text-old-n-black-100 font-semibold tracking-xs3;
}

p {
  @apply text-old-n-black-80 text-base;
}

</style>
